import { ReelSpin } from "./ReelSpin";
// import { Ui } from "../ui/Ui"
import { Spine } from '@esotericsoftware/spine-pixi-v8';
import { gsap } from "gsap";
import { /*BlurFilter, ColorMatrixFilter,*/ BitmapText, Container, Point } from 'pixi.js';
import { /*Tween,*/ Group, Tween } from "tweedle.js";

// import { ColorOverlayFilter } from "pixi-filters";
import { /*SpinDataObject,*/ spinData, WinObject } from '../../server/getServerResposesFun';
// import { TextAnimate } from "./TextAnimate"
// import { isOversizeSymbol } from "../config/getSymbol";

import {
    PAYLINE_SPINE_X,
    PAYLINE_SPINE_Y,
    REEL_DIVIDER,
    REEL_NUMBERS,
    REEL_WIDTH,
    SYMBOL_HEIGHT,
    SYMBOLS_PER_REEL,
} from "../../config/reelConfig";

import { sound } from "@pixi/sound";
import { ReelCellComponent } from "../../components/reelCellContainer/ReelCellComponent";
import { WinMeterComponent } from "../../components/winmeters/WinMeterComponent";
import { isQuickBtnOnGlobal, isSuperQuickBtnOnGlobal } from "../../config/GlobalVariableConfig";
import { SoundConstants } from "../../gameClientEvents/soundConstants";
import { wait } from "../../utils";
import { DisplayComponent } from "../displays/DisplayComponent";
import { reelSpinEmitter } from "./ReelInit";

/** Pause after line win amount appears, before flying multipliers from symbols. */
const LINE_WIN_MULTI_COLLECT_DELAY_MS = {
    superQuick: 350,
    normal: 750,
} as const;

const LINE_WIN_TOTAL_TICKUP_MS = 200;

// const style = new TextStyle({
//     fill: "#ffffff",
//     fontFamily: "Arial Black",
//     fontSize: 50
// });


// const lineWinTextStyle = new TextStyle({
//     fontFamily: 'Helvetica',
//     fontSize: 100,
//     // fill: "#fed716",
//     fill: "#ffffff",
//     fontWeight: "bold",
//     stroke: '#000000',
//     // stroke: '#4a1850',
//     dropShadow: true,

// });

let lineWinText: BitmapText;

let winAmountFxSpine: Spine | null = null;
let reelMultiMergeSpine: Spine | null = null;

export let lineWinTextContainer: Container;

let textTweenGroup: Group;

let lineWinTextFloatTween: gsap.core.Timeline | null = null;

type LineWinTextBase = {
    x: number;
    y: number;
    scaleX: number;
    scaleY: number;
    rotation: number;
    alpha: number;
};

let lineWinTextBase: LineWinTextBase = {
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1,
    rotation: 0,
    alpha: 1,
};

function applyLineWinTextScale(): number {
    lineWinText.scale.set(1);
    const textScale = Math.min(850 / lineWinText.width, 1);
    lineWinText.scale.set(textScale);
    return textScale;
}

function stopLineWinTextEffects(resetTransform = true): void {
    lineWinTextFloatTween?.kill();
    lineWinTextFloatTween = null;
    gsap.killTweensOf(lineWinText);
    gsap.killTweensOf(lineWinText.scale);

    if (resetTransform) {
        lineWinText.x = lineWinTextBase.x;
        lineWinText.y = lineWinTextBase.y;
        lineWinText.scale.set(lineWinTextBase.scaleX, lineWinTextBase.scaleY);
        lineWinText.rotation = lineWinTextBase.rotation;
        lineWinText.alpha = lineWinTextBase.alpha;
    }
}

function storeLineWinTextBase(): void {
    lineWinTextBase = {
        x: lineWinText.x,
        y: lineWinText.y,
        scaleX: lineWinText.scale.x,
        scaleY: lineWinText.scale.y,
        rotation: lineWinText.rotation,
        alpha: lineWinText.alpha,
    };
}

function startLineWinTextFloating(): void {
    stopLineWinTextEffects(true);
    storeLineWinTextBase();

    const base = lineWinTextBase;
    const bob = isSuperQuickBtnOnGlobal ? 8 : 12;
    const duration = isSuperQuickBtnOnGlobal ? 0.9 : 1.2;

    lineWinTextFloatTween = gsap.timeline({ repeat: -1, yoyo: true });
    lineWinTextFloatTween
        .to(
            lineWinText,
            {
                y: base.y - bob,
                rotation: 0.035,
                duration,
                ease: "sine.inOut",
            },
            0
        )
        .to(
            lineWinText.scale,
            {
                x: base.scaleX * 1.08,
                y: base.scaleY * 1.08,
                duration,
                ease: "sine.inOut",
            },
            0
        );
}

export function playLineWinTextSpawnPop(): void {
    stopLineWinTextEffects(true);
    storeLineWinTextBase();

    const base = lineWinTextBase;
    lineWinText.alpha = 0;
    lineWinText.rotation = 0;
    lineWinText.scale.set(0, 0);

    gsap
        .timeline({ onComplete: () => startLineWinTextFloating() })
        .to(lineWinText, { alpha: 1, duration: 0.4, ease: "power2.out" }, 0)
        .fromTo(
            lineWinText.scale,
            { x: 0, y: 0 },
            {
                x: base.scaleX * 1.3,
                y: base.scaleY * 1.3,
                duration: 0.22,
                ease: "back.out(2)",
            },
            0
        )
        .to(
            lineWinText.scale,
            {
                x: base.scaleX,
                y: base.scaleY,
                duration: 0.18,
                ease: "power2.out",
            },
            0.22
        );
}

/** Pop when a multiplier segment merges into line win text. */
export function playLineWinTextMultiplierMergePop(): void {
    stopLineWinTextEffects(true);
    applyLineWinTextScale();
    storeLineWinTextBase();

    const base = lineWinTextBase;

    gsap
        .timeline({ onComplete: () => startLineWinTextFloating() })
        .to(lineWinText.scale, {
            x: base.scaleX * 1.15,
            y: base.scaleY * 1.15,
            duration: 0.1,
            ease: "back.out(2)",
        })
        .to(lineWinText.scale, {
            x: base.scaleX,
            y: base.scaleY,
            duration: 0.15,
            ease: "power2.out",
        });
}

export function fadeOutLineWinText(): Promise<void> {
    return new Promise((resolve) => {
        if (!lineWinText.text) {
            resolve();
            return;
        }

        stopLineWinTextEffects(false);

        gsap
            .timeline({
                // onStart: () => {
                //     resolve();
                // },
                // onInterrupt: () => {
                //     console.log("Interrupted");
                // },
                // onUpdate: () => {
                //     if (lineWinText.alpha < 0.5) {
                //         resolve();
                //     }
                // },
                onComplete: () => {
                    lineWinText.text = "";
                    lineWinText.alpha = 1;
                    lineWinText.rotation = 0;
                    sound.play(SoundConstants.TOTAL_DISAPPEAR, { volume: 1 });
                    lineWinText.x = lineWinTextBase.x;
                    lineWinText.y = lineWinTextBase.y;
                    lineWinText.scale.set(1);
                    resolve();
                },
            })
            .to(
                lineWinText,
                {
                    y: lineWinText.y - (isSuperQuickBtnOnGlobal ? 25 : 50),
                    alpha: 0,
                    duration: isSuperQuickBtnOnGlobal ? 0.05 : 1,
                    ease: "power1.out",
                },
                0
            )
            .to(
                lineWinText.scale,
                {
                    x: lineWinText.scale.x * 1.15,
                    y: lineWinText.scale.y * 1.15,
                    duration: 0.3,
                    ease: "back.out(1.5)",
                },
                0
            )
            .to(
                lineWinText.scale,
                {
                    x: 0,
                    y: 0,
                    duration: 0.5,
                    ease: "power2.out",
                    onStart: () => {
                        sound.play(SoundConstants.WIN_AMOUNT_DISAPPEARS, { volume: 0.5 });
                    },
                },
                0.3
            );
    });
}

function setLineWinTextWithSpawn(text: string): void {
    lineWinText.text = text;
    applyLineWinTextScale();
    storeLineWinTextBase();
    playLineWinTextSpawnPop();
}

export type LineWinTextSegment = 'amount' | 'multiplier';

type LineWinTextLayout = {
    fullW: number;
    amountCenterX: number;
    multiplierCenterX: number;
};

function measureLineWinTextWidth(text: string): number {
    if (!text) return 0;
    const probe = new BitmapText({
        text,
        style: lineWinText.style,
    });
    const w = probe.width;
    probe.destroy();
    return w;
}

function getLineWinTextLayout(displayText: string): LineWinTextLayout {
    const xIdx = displayText.indexOf(' x ');
    const fullW = measureLineWinTextWidth(displayText);

    if (xIdx < 0) {
        return {
            fullW,
            amountCenterX: 0,
            multiplierCenterX: fullW / 2,
        };
    }

    const amountStr = displayText.substring(0, xIdx);
    const multiStr = displayText.substring(xIdx);
    const amountW = measureLineWinTextWidth(amountStr);
    const multiW = measureLineWinTextWidth(multiStr);

    return {
        fullW,
        amountCenterX: -fullW / 2 + amountW / 2,
        multiplierCenterX: -fullW / 2 + amountW + multiW / 2,
    };
}

/** Global position of the amount or multiplier segment in line win text. */
export function getLineWinSegmentGlobalPoint(
    segment: LineWinTextSegment,
    displayText?: string
): Point {
    const layout = getLineWinTextLayout(displayText ?? lineWinText.text);
    const localX =
        segment === 'amount'
            ? layout.amountCenterX
            : layout.multiplierCenterX;
    return lineWinText.toGlobal(new Point(localX, 0));
}

export function playLineWinAmountFx(displayText?: string): void {
    const fx = winAmountFxSpine;
    if (!fx) return;

    const text = displayText ?? lineWinText.text;
    const layout = getLineWinTextLayout(text);

    fx.visible = true;
    fx.x = layout.amountCenterX;
    fx.y = 0;
    fx.scale.set(Math.max(layout.fullW / 500, 1));
    fx.state.timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
    fx.state.clearTracks();

    const animName = fx.skeleton.data.animations?.[0]?.name;
    if (!animName) {
        fx.visible = false;
        return;
    }

    fx.state.setAnimation(0, animName, false).listener = {
        complete: () => {
            fx.visible = false;
            fx.state.clearListeners();
        },
    };
}

export function playLineWinMultiplierMergeFx(displayText?: string): void {
    const fx = reelMultiMergeSpine;
    if (!fx) return;

    const text = displayText ?? lineWinText.text;
    const layout = getLineWinTextLayout(text);

    fx.visible = true;
    fx.x = layout.multiplierCenterX + 60;
    fx.y = 15;
    fx.scale.set(Math.max(layout.fullW / 500, 1));
    fx.state.timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
    fx.state.clearTracks();
    sound.play(SoundConstants.TALLY_TOTALING, { volume: 1 });
    fx.state.setAnimation(0, 'multi_marge_fx', false).listener = {
        complete: () => {
            fx.visible = false;
            fx.state.clearListeners();
        },
    };
}

export class ReelWin extends ReelSpin {


    private winSymbolArray: number[][] = [];

    private winLines: WinObject[] | null = null; // object for winning Lines
    // Uncomment once the backend is fixed
    // private winScatters: WinObject[] | null = null; // object for winning Scatters



    // private totalWin: number = 0;

    private winLinesSPine: Spine | null = null;

    constructor() {
        super();

        lineWinText = new BitmapText({
            text: '',
            style: {
                fontFamily: "symbol_multiplier",
                trim: true,
                fontSize: 75,
                letterSpacing: 10,
            }

        });
        lineWinText.label = "lineWinText";

        lineWinTextContainer = new Container();
        lineWinTextContainer.label = "lineWinTextContainer";
        textTweenGroup = new Group();
        // this.lineWinText.text = "";
        // this.lineWinText.style = style;

        // this.lineWinText.x = 500;
        // this.lineWinText.y = -100;

        // this.reelOverlayContainer.addChild(this.lineWinText);

        textTweenGroup.removeAll();
        this.setWinLineSpineObj();
        this.setWinAmountFxObj();
        this.setMultiMergeFxObj();
    }


    public updateReelWin() {
        this.updateReelSpin();

        textTweenGroup.update();

    }

    private setWinObjectsVal(currentRespinIndex: number) {
        // this.setWinObjectsVal();
        this.winLines = spinData.respins[currentRespinIndex].winLines;

        // Uncomment once the backend is fixed
        // this.winScatters = spinData.respins[currentRespinIndex].winScatters;



        // console.log(spinData.respins[currentRespinIndex].winAmount);
        // this.totalWin = spinData.respins[currentRespinIndex].winAmount;
    }

    private setWinLineSpineObj() {

        this.winLinesSPine = Spine.from({
            skeleton: "winLineSkel",
            atlas: "winLineAtlas",
        });
        this.winLinesSPine.label = "winLine spine";
        this.winLinesSPine.state.clearTracks();
        this.winLinesSPine.x = PAYLINE_SPINE_X;
        this.winLinesSPine.y = PAYLINE_SPINE_Y;
        this.paylineOverlayContainer.addChild(this.winLinesSPine);
    }

    private setWinAmountFxObj() {
        try {
            winAmountFxSpine = Spine.from({
                skeleton: "winAmountFxSkel",
                atlas: "winAmountFxAtlas",
            });
            winAmountFxSpine.label = "winAmountFx spine";
            winAmountFxSpine.visible = false;
            winAmountFxSpine.state.clearTracks();
            lineWinTextContainer.addChildAt(winAmountFxSpine, 0);
        } catch (e) {
            winAmountFxSpine = null;
            console.warn("winAmountFx spine init failed", e);
        }
    }

    private setMultiMergeFxObj() {
        try {
            reelMultiMergeSpine = Spine.from({
                skeleton: "reelMultiMergeSkel",
                atlas: "reelMultiMergeAtlas",
            });
            reelMultiMergeSpine.label = "reelMultiMerge spine";
            reelMultiMergeSpine.visible = false;
            reelMultiMergeSpine.state.clearTracks();
            lineWinTextContainer.addChild(reelMultiMergeSpine);
        } catch (e) {
            reelMultiMergeSpine = null;
            console.warn("reelMultiMerge spine init failed", e);
        }
    }

    private playWinAmountFx(displayText?: string): void {
        playLineWinAmountFx(displayText);
    }

    // private async waitFunction(time: number): Promise<void> {
    //     return new Promise((resolve) => {

    //         setTimeout(() => {
    //             resolve();
    //         }, time);

    //     })
    // }

    private initWinSymbolArray() {
        // Initialize winSymbolArray with zeros
        for (let i = 0; i < REEL_NUMBERS; i++) {
            this.winSymbolArray[i] = [];
            for (let j = 0; j < SYMBOLS_PER_REEL; j++) {
                this.winSymbolArray[i][j] = 0; // Initialize to 0
            }
        }
    }

    // export interface WinObject { // the object -how we want to use in our program
    //     lineId: number | null;
    //     symbolId: number;
    //     winAmount: number;
    //     winSymbolPosistions: number[][]| null;
    // }


    private setWinSymbolArray(winObjects: WinObject[]) {
        // Iterate through winLines
        winObjects?.forEach((winObject) => {
            if (winObject.winSymbolPosistions) {
                // Adjust the type of reelNum and posNum to number

                winObject.winSymbolPosistions.forEach((winSymbolPosistion) => {

                    const reelNum: number = winSymbolPosistion[0];
                    const posNum: number = winSymbolPosistion[1];

                    // Mark the position as 1
                    this.winSymbolArray[reelNum][posNum] = 1;
                })
            }
        });
    }

    private getWinLineNmubers(): number[] {
        const winLineNmubers: number[] = [];//(number | null)[] | null  = null;  // define in a better way numbers[] | null

        this.winLines?.forEach((winLine) => {

            if (winLine.lineId) {
                winLineNmubers.push(winLine.lineId);
            }

        })

        // this.winlineNumbers = spinData.winLines?.map(line => line.lineId) ?? null; //[1, 2, 3]; // ?? null to change undefined value to null

        // when use in toggeling -> empty this array and push single line id, in the animation function use winlineNumbers.length

        return winLineNmubers;
    }



    // this is main function which is doing the animation -

    //this will just makeNonwinSymbolDark
    public async animateWinningSymbols(currentRespinIndex: number): Promise<void> {

        // console.log("inside animateWinningSymbols");

        this.setupLineWintext();

        this.setWinObjectsVal(currentRespinIndex);
        //this.setWinLineSpineObj();

        // this pause is mandatory to settle all reels, and observe the landing animations before starting next spin, specially in auto play
        if (spinData.respins[currentRespinIndex].winAmount == 0) {
            // console.log("no win");

            // await this.waitFunction(500);

            this.running = false;

            return Promise.resolve();
        }



        // console.log(this.spinData.winScatters);




        // if (winLines?.length == 0 && winScatters?.length == 0) {

        //     this.running = false;
        //     console.log(`running ${this.running}`);
        // }

        this.initWinSymbolArray();


        this.winLines?.forEach((winLine) => {

            const winlines: WinObject[] = [];
            winlines.push(winLine)

            this.setWinSymbolArray(winlines);
        })


        // Uncomment once the backend is fixed
        // this.winScatters?.forEach((winScatter) => {

        //     const winScatters : WinObject[] = [];
        //     winScatters.push(winScatter)

        //     this.setWinSymbolArray(winScatters);
        // })

        const winlineNumbers: number[] = this.getWinLineNmubers();

        // setWinSymbolArray

        console.log(winlineNumbers);


        // await this.animateWinningLines(winlineNumbers);

        // await this.makeNonwinSymbolDark();

        // await this.waitFunction(500),

        console.log("all line animations are completed");

        // return this.totalWin;

        // await this.lineLoggle(currentRespinIndex);



    }

    private resetSymbolLayer() {
        // adjust the layering
        this.allReelArray.forEach((reelObj) => {
            reelObj.symbols.forEach((symbol) => {
                reelObj.container.addChild(symbol.view);
            })
        })
    }

    private winningSymbolOnTop() {
        // this.reset
        // first take winning symbol on top
        this.winSymbolArray.forEach((reels, reelNum) => {
            reels.forEach((symbol, posNum) => {
                if (symbol == 1) // win animation
                {
                    // console.log(`reelNum ${reelNum}`);
                    // console.log(`posNum ${posNum}`);

                    // take them on top
                    const reelObj = this.allReelArray[reelNum];
                    const winSymbol = reelObj.symbols[posNum];
                    reelObj.container.addChild(winSymbol.view);

                    // let winSymbol = this.reelOverlayContainer.getChildByLabel(`${reelNum * 3 + posNum}`) as Spine;
                    // this.reelOverlayContainer.addChild(winSymbol);

                }
            })
        })

        // then take oversized symbol on top of that
        // this.winSymbolArray.forEach((reels, reelNum) => {
        //     reels.forEach((symbol, posNum) => {
        //         if (symbol == 1) // win animation
        //         {
        //             const symbolId: number = this.allReelArray[reelNum].symbols[posNum].y;

        //             if (isOversizeSymbol(symbolId)) // symbolId of oversized symbols
        //             {
        //                 const winSymbol: Spine | null = this.reelOverlayContainer.getChildByLabel(`${reelNum * 3 + posNum}`) as Spine;
        //                 this.reelOverlayContainer.addChild(winSymbol)
        //             }
        //         }
        //     })
        // })
    }


    // Function to calculate position based on lineNumber

    private getTextAnimatePos(): number {
        // // Function to find the first winning position on reel 3
        // const firstWinPosOnReel3 = (): number | undefined => {
        //     for (let i = 0; i < this.winSymbolArray[2].length; i++) {
        //         if (this.winSymbolArray[2][i] === 1) {
        //             return (i); // Return the position
        //         }
        //     }
        //     return undefined; // If no win position is found
        // }

        // const firstWinPos = firstWinPosOnReel3(); // Get the first win position
        // if (firstWinPos !== undefined) {
        //     const position = (firstWinPos + 0.75) * SYMBOL_HEIGHT;

        //     return position;
        // }

        // // Handle the case where no win position is found (default value)
        // return 0;

        // console.log("getTextAnimatePos", this.winSymbolArray);


        const mappedArray = this.winSymbolArray[0].map((_, colIndex) =>
            this.winSymbolArray.some(row => row[colIndex] === 1) ? 1 : 0
        );

        // Step 2: Get indexes with 1s
        const indexesWithOnes = mappedArray
            .map((value, index) => (value === 1 ? index : -1))
            .filter(index => index !== -1);

        // Step 3: Calculate Median
        let median: number;
        const len = indexesWithOnes.length;

        if (len === 0) {
            median = -1; // Handle case with no 1s
        } else if (len % 2 === 0) {
            median = (indexesWithOnes[len / 2 - 1] + indexesWithOnes[len / 2]) / 2;
        } else {
            median = indexesWithOnes[Math.floor(len / 2)];
        }

        // console.log("Mapped Array:", mappedArray);        // [1, 1, 1, 1, 1, 0]
        // console.log("Indexes with 1s:", indexesWithOnes); // [0, 1, 2, 3, 4]
        // console.log("Median index:", median);             // 2

        return (median + 0.5) * SYMBOL_HEIGHT;


    }



    private async runAnimation(winlineNumbers: number[]): Promise<void> // play animation of symbols having value 1 in the array winSymbolArray
    {

        winlineNumbers;
        console.log("inside runAnimation");

        let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;

        const animationPromises: Promise<void>[] = [];

        //const winLineAnimationPromise = this.playWinLineAnimations(winlineNumbers, timeScale);
        //animationPromises.push(winLineAnimationPromise);

        // Clear any existing tracks
        //this.winLinesSPine?.state.clearTracks();


        this.winSymbolArray.forEach((reels, reelNum) => {
            reels.forEach((value, posNum) => {
                let symbol = this.allReelArray[reelNum].symbols[posNum].symbol;
                if (value == 1) {
                    const animationPromise = new Promise<void>((resolve) => {
                        sound.play(SoundConstants.SYMBOL_WIN, { volume: 1});
                        symbol.state.setAnimation(0, "win", false).listener = {
                            complete: () => {
                                resolve();
                                symbol.state.clearListeners();
                            }
                        }
                        symbol.state.timeScale = timeScale;
                    })

                    animationPromises.push(animationPromise);
                }
            }
            )
        })

        try {
            if (animationPromises.length > 0) {
                reelSpinEmitter.emit("winsStarted");
                await Promise.all(animationPromises);
            }
        } catch (error) {
            console.error("Error during runAnimation:", error);
            throw error;
        }

    }

    private async animateWinningLines(winlineNumbers: number[], winAmt?: number, currentMult?: number): Promise<void> {
        // If winAmt is 0, resolve the promise immediately
        if (winAmt === 0) {
            return Promise.resolve();
        }
        console.log(winlineNumbers);
        // Clear any existing tracks
        //this.winLinesSPine?.state.clearTracks();

        // Set paying line (numbers) - animations for each winning line
        // for (let currentLineIndex = 0; currentLineIndex < winlineNumbers.length; currentLineIndex++) {
        //     const winLineId = winlineNumbers[currentLineIndex];
        //     const winAnimationName = `payline_${winLineId}`;
        //     console.log("Spine animations ==> ", this.winLinesSPine.skeleton.data.animations);
        //     this.winLinesSPine?.state.setAnimation(currentLineIndex, winAnimationName, false); // Play the animation once
        // }

        // Handle winning symbols
        this.winningSymbolOnTop();

        // Add the win lines spine to the overlay container if there are winning lines
        // if (winlineNumbers.length > 0 && this.winLinesSPine) {
        //     this.reelOverlayContainer.addChild(this.winLinesSPine);
        // }

        // Initialize text animation if winAmt is non-zero
        // let textanimate: TextAnimate | null = null;
        if (winAmt) {
            // const texttickupDuration = 0;
            // const textanimationDuration = 500;
            // const decimalPlace = 2;


            const textAnimationY = this.getTextAnimatePos();
            lineWinTextContainer.y = textAnimationY - 250;


            // Run both updateNumberText and runAnimation concurrently
            await Promise.all([
                this.runAnimation(winlineNumbers),
                this.updateNumberText(winAmt / currentMult, currentMult),
            ]);

        }
        else {
            await this.runAnimation(winlineNumbers);
        }

        this.resetSymbolLayer();

    }

    private async animateWinLine(winlineNumbers: number[], winAmt?: number, currentMult?: number, currentRespinIndex?: number): Promise<void> {

        console.log("animateWinLine for ", currentRespinIndex, "index", winlineNumbers, winAmt, currentMult)
        // // If winAmt is 0, resolve the promise immediately
        // if (winAmt === 0) {
        //     return Promise.resolve();
        // }

        // Handle winning symbols
        this.winningSymbolOnTop();

        // Add the win lines spine to the overlay container if there are winning lines
        if (winlineNumbers.length > 0 && this.winLinesSPine) {
            this.reelOverlayContainer.addChild(this.winLinesSPine);
        }

        // on top of reelOverlayContainer
        //this.reelOverlayContainer.addChild(lineWinTextContainer);

        // Initialize text animation if winAmt is non-zero
        // let textanimate: TextAnimate | null = null;
        if (winAmt) {
            // const texttickupDuration = 0;
            // const textanimationDuration = 500;
            // const decimalPlace = 2;


            const textAnimationY = this.getTextAnimatePos();
            lineWinTextContainer.y = textAnimationY - 250;

            await Promise.all([
                this.runAnimation(winlineNumbers),
                this.updateNumberText(winAmt / currentMult, currentMult)

            ]);

        }
        else {
            await this.runAnimation(winlineNumbers);
        }

        this.resetAllSymbols()

    }

    private setupLineWintext() {

        lineWinText.anchor = 0.5;
        lineWinTextContainer.addChild(lineWinText);

        //this.reelOverlayContainer.addChild(lineWinTextContainer);

        // new TextAnimate(textTweenGroup, winAmt, decimalPlace, texttickupDuration, textanimationDuration);
        lineWinTextContainer.x = ((REEL_WIDTH * REEL_NUMBERS + (REEL_NUMBERS - 1) * REEL_DIVIDER) / 2) - 450;


    }


    private tickupLineWinTotal(fromVal: number, toVal: number): Promise<void> {
        return new Promise((resolve) => {
            lineWinText.text = fromVal.toFixed(2);
            applyLineWinTextScale();
            let previousWidth = lineWinText.width;

            const tweenToTickup = new Tween({ x: fromVal }, textTweenGroup)
                .to({ x: toVal }, LINE_WIN_TOTAL_TICKUP_MS)
                .onStart(() => {
                    // if (!this.isWinHigherBet) {
                    //     sound.play('symbol_win_multiply', { volume: 0.15 });
                    // } else {
                        sound.play(SoundConstants.TALLY_WIN_AMOUNT, { volume: 0.35 });
                    // }
                })
                .onUpdate((object) => {
                    lineWinText.text = object.x.toFixed(2);
                    if (lineWinText.width > previousWidth) {
                        applyLineWinTextScale();
                        previousWidth = lineWinText.width;
                    }
                })
                .onComplete(() => {
                    const totalText = toVal.toFixed(2);
                    lineWinText.text = totalText;
                    applyLineWinTextScale();
                    storeLineWinTextBase();
                    playLineWinTextSpawnPop();
                    textTweenGroup.remove(tweenToTickup);
                    resolve();
                })
                .start();
        });
    }

    private async updateNumberText(winAmt: number, currentMult?: number): Promise<void> {
        // console.log(`currentMult ${currentMult}`);
        return new Promise(async (resolve) => {
            stopLineWinTextEffects(true);
            lineWinText.x = 0;
            lineWinText.y = 0;
            lineWinText.rotation = 0;
            lineWinText.alpha = 1;
            storeLineWinTextBase();

            if (currentMult && currentMult > 1) {
                setLineWinTextWithSpawn(`${winAmt.toFixed(2)}`);
                this.playWinAmountFx();

                const collectDelayMs = isSuperQuickBtnOnGlobal
                    ? LINE_WIN_MULTI_COLLECT_DELAY_MS.superQuick
                    : LINE_WIN_MULTI_COLLECT_DELAY_MS.normal;
                await wait(collectDelayMs);

                const promises: Promise<void>[] = [];
                for (let reelNum = 0; reelNum < this.winSymbolArray.length; reelNum++) {
                    for (let posNum = 0; posNum < this.winSymbolArray[reelNum].length; posNum++) {
                        const multiplerStatus = DisplayComponent.get(WinMeterComponent).getInstance().getStatusOfMultiplier(reelNum, posNum);
                        if (this.winSymbolArray[reelNum][posNum] == 1 && multiplerStatus.visible) {
                            const promise = new Promise<void>(async (resolve) => {
                                DisplayComponent.get(WinMeterComponent).getInstance().addMultiplierToWinText(reelNum, posNum, lineWinTextContainer.x + lineWinTextContainer.width, lineWinTextContainer.y, lineWinText, winAmt, this.isWinHigherBet, currentMult, resolve);
                            });
                            await new Promise(resolve => setTimeout(resolve, 150));
                            promises.push(promise);
                        }

                    }
                }
                if (promises.length > 0) {
                    await Promise.all(promises);
                    DisplayComponent.get(WinMeterComponent).getInstance().resetPrevTotalMulti();
                }
            }
            if (isSuperQuickBtnOnGlobal) {

                const targetVal: number = winAmt * (currentMult ?? 1);
                if (currentMult && currentMult > 1) {
                    await this.tickupLineWinTotal(winAmt, targetVal);
                } else {
                    const totalText = targetVal.toFixed(2);
                    setLineWinTextWithSpawn(totalText);
                    this.playWinAmountFx(totalText);
                }

                if (/*["uk", "ontario"].indexOf(jurisdictionGlobal) !== -1 && */!this.isWinHigherBet) {
                    sound.play('symbol_win', { volume: 0.6 })
                    // console.log("symbol_win = 0.2")
                }
                else {
                    sound.play('symbol_win_multiply', { volume: 0.6 })
                    console.log("symbol_win_multiply = 0.6")
                }

                await new Promise(resolve => setTimeout(resolve, 500));

                await fadeOutLineWinText();

                resolve();

                return;
            }


            // if super turbo is not there

            if (currentMult && currentMult > 1) {
                //lineWinText.text = `${winAmt.toFixed(2)}`;//`${winAmt.toFixed(2)} x ${currentMult}`;
            }
            else {
                setLineWinTextWithSpawn(`${winAmt.toFixed(2)}`);
                this.playWinAmountFx();
            }

            if (/*["uk", "ontario"].indexOf(jurisdictionGlobal) !== -1 &&*/ !this.isWinHigherBet) {
                sound.play('symbol_win', { volume: .6 })
                // console.log("symbol_win = 0.2")
            }
            else {
                // sound.play('symbol_win', { volume: .3 })
                sound.play('symbol_win_multiply', { volume: .6 })
                console.log("symbol_win_multiply = 0.6")
            }

            await new Promise(resolve => setTimeout(resolve, 500));

            if (currentMult && currentMult > 1) {
                await this.tickupLineWinTotal(winAmt, winAmt * currentMult);
                await new Promise(resolve => setTimeout(resolve, 500));
            }
            else {
                await new Promise(resolve => setTimeout(resolve, 500));
            }

            await fadeOutLineWinText();

            resolve();
        })

    }






    public async processWinFeatureSymbol(currentRespinIndex: number): Promise<void> {


        // let currentRespinIndex: number = 0;//spinData.respins.length-1;
        console.log("inside processWinFeatureSymbol", currentRespinIndex, spinData.respins[currentRespinIndex - 1]);
        const winScatter = spinData.respins[currentRespinIndex - 1].winScatters ? spinData.respins[currentRespinIndex - 1].winScatters[0] : null;
        if (winScatter == null) return;
        console.log("inside processWinFeatureSymbol", winScatter);


        // sound.play('scatter_win', { volume: 0.7 })

        this.initWinSymbolArray();


        if (winScatter) {
            const winScatters: WinObject[] = [];
            winScatters.push(winScatter);

            this.setWinSymbolArray(winScatters);

            let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;

            sound.play('Scatter_Trigger', { speed: timeScale });
            await this.animateWinningLines([]);
        }

    }


    /*********************** Line Toggle ******************** */
    protected async processWinObjectsToggel(winObjects: WinObject[] | null, winSymbolIds: number[], currentIndex: number, isLine: boolean): Promise<void> {
        if (winObjects?.length === 0) {
            // console.log(`No win ${isLine ? 'lines' : 'scatters'} to process.`);
            return;
        }

        if (winObjects === null) {
            return;
        }

        // Reset the index if it exceeds the length of winObjects
        if (currentIndex >= winObjects.length) {
            return;
        }

        // console.log(`toggelwin ${isLine ? 'lines' : 'scatters'} to process.`);
        // console.log(winObjects);

        const currentObjects: WinObject[] = [];
        let winAmt = 0;

        winObjects.forEach((winObject) => {
            if (winObject.symbolId === winSymbolIds[currentIndex]) {
                currentObjects.push(winObject);
                winAmt += winObject.winAmount;
            }
        })


        // console.log("processWinObjectsToggel", currentObjects);

        // const winSymbolPosistion = currentObject.winSymbolPosistions;
        // const winAmt = currentObject.winAmount;

        // console.log(winSymbolPosistion);
        // console.log(winAmt);

        // this.lineWinText.text = `${winAmt}`;


        // Reset original position
        // this.resetWinContainer();

        // Initialize winSymbolArray with zeros
        this.initWinSymbolArray();

        this.setWinSymbolArray(currentObjects);


        // console.log(winSymbolArray);

        const lineId = isLine ? winObjects[currentIndex].lineId : null;
        const winlineNumbers: number[] = [];
        if (lineId) {
            winlineNumbers.push(lineId);
        }

        //const currentMult = winObjects[currentIndex].winMultiplier;
        //let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
        //await this.playWinLineAnimations(winlineNumbers, timeScale);
        // const winLineAnimationPromise = this.playWinLineAnimations(winlineNumbers, timeScale);
        // animationPromises.push(winLineAnimationPromise);
        //await this.animateWinningLines(winlineNumbers, winAmt, currentMult);

        // await this.animateWinLinesSymbol(winSymbolArray, lineId, winLinesSPine, winAmt, true);

        // Move to the next index and call the function recursively
        await this.processWinObjectsToggel(winObjects, winSymbolIds, currentIndex + 1, isLine);
    }

    private isWinHigherBet: boolean = false;

    protected async processAllRepeatedly(currentRespinIndex: number): Promise<void> {
        return new Promise(async (resolve) => {
            this.isWinHigherBet = spinData.respins[currentRespinIndex].isWinHigherBet
            if (spinData.respins[currentRespinIndex].winAmount == 0) {
                // this.running = false;
                resolve();
            }
            else {

                //  this.setWinSymbolArray(this.winScatters);

                this.winLines = spinData.respins[currentRespinIndex].winLines;

                const winSymbolIds = [...new Set(
                    this.winLines.map(line => line.symbolId)
                )];

                for (let i = 0; i < winSymbolIds.length; i++) {

                    const symbolId = winSymbolIds[i];

                    const matchingWinLines = this.winLines.filter(line => line.symbolId === symbolId);

                    // Unique multipliers for this symbol
                    const multipliers = [...new Set(
                        matchingWinLines.map(line => line.winMultiplier)
                    )];

                    // Loop multiplier groups
                    for (let m = 0; m < multipliers.length; m++) {

                        const multiplier = multipliers[m];

                        // Filter only winLines having this multiplier
                        const linesForMultiplier = matchingWinLines.filter(
                            line => line.winMultiplier === multiplier
                        );

                        const winLineNumbers = [...new Set(
                            linesForMultiplier.map(line => line.lineId)
                        )];

                        let winAmount = 0;
                        linesForMultiplier.forEach(line => {
                            winAmount += line.winAmount;
                        });

                        this.initWinSymbolArray();
                        this.setWinSymbolArray(linesForMultiplier);

                        this.makeNonwinSymbolDark();

                        await this.animateWinLine(winLineNumbers, winAmount, multiplier, currentRespinIndex);

                        if (winSymbolIds.length > 1) {
                            if (!isSuperQuickBtnOnGlobal && !isQuickBtnOnGlobal) {
                                await new Promise(resolve => setTimeout(resolve, 200));
                            }
                        }
                    }
                }


            }

            console.log("all line animations are completed");

            resolve();
        })

        //const winLines: WinObject[] | null = spinData.respins[currentRespinIndex].winLines;

        // Uncomment once the backend is fixed
        // const winScatters: WinObject[] | null = spinData.respins[currentRespinIndex].winScatters;

        // const currentMult: number = spinData.respins[currentRespinIndex].multiplier

        // map(line => line.lineId)

        //this.isWinHigherBet = spinData.respins[currentRespinIndex].isWinHigherBet

        // const allWinSymbolIds = spinData.respins[currentRespinIndex].winLines?.map(line => line.symbolId) || [];   //[1, 2, 2, 3, 4, 4, 5];
        // const winSymbolIds = allWinSymbolIds.filter((value, index, self) => self.indexOf(value) === index);


        // // while (true) {
        // if (winLines?.length ?? 0 > 0) {
        //     await this.processWinObjectsToggel(winLines, winSymbolIds, 0, true);
        // }

        // Uncomment once the backend is fixed
        // if (winScatters?.length ?? 0 > 0) {
        //     await this.processWinObjectsToggel(winScatters, winSymbolIds,  0, currentMult, false);
        // }
        // }
    }


    public async lineToggle(currentRespinIndex: number) {

        // await this.makeNonwinSymbolDark();



        console.log("inside lineToggle");


        // if (this.running == false) { // toggel animation

        // this.resetWinContainer();// reset symbols before line toggle
        // this.lineWinText.text = "";

        // Call the function to process both win lines and win scatters repeatedly

        if (spinData.respins[currentRespinIndex].winAmount > 0) {
            // await new Promise(resolve => setTimeout(resolve, 100));
            this.makeNonwinSymbolDark();

            await this.processAllRepeatedly(currentRespinIndex);

            await this.blastAnimation(currentRespinIndex);

        }
        else {
            await new Promise(resolve => setTimeout(resolve, 100));
        }



        this.resetAllSymbols();

    }

    protected makeNonwinSymbolDark() {

        // const animationPromises: Promise<void>[] = [];


        let winSymbolFound = false;
        this.winSymbolArray.forEach((reels) => {
            reels.forEach((symbol) => {
                if (symbol != 0) {
                    winSymbolFound = true;
                }
            });
        });

        if (!winSymbolFound) {
            return;
        }

        // const colorOverlayFilter = new ColorOverlayFilter();
        // colorOverlayFilter.color = "#000000";
        // colorOverlayFilter.alpha = 0;

        // const tween = new Tween(colorOverlayFilter, textTweenGroup)
        //     .to({ alpha: 0.7 }, 100)
        //     .onComplete(() => {
        //         textTweenGroup.remove(tween);
        //     })
        //     .start();

        this.winSymbolArray.forEach((reels, reelNum) => {
            reels.forEach((symbol, posNum) => {
                if (symbol === 0) { // non winning symbol which will be de-highlighted


                    let nonWinSymbol = this.allReelArray[reelNum].symbols[posNum].view;

                    // nonWinSymbol.filters = colorOverlayFilter;
                    nonWinSymbol.tint = "0x222222";
                    DisplayComponent.get(ReelCellComponent).getInstance().makeDark(reelNum, posNum);
                    DisplayComponent.get(WinMeterComponent).getInstance().makeDark(reelNum, posNum);
                }
            });
        });

        // const tween = new Tween(colorOverlayFilter, textTweenGroup)
        //     .to({ alpha: 0.7 }, 100)
        //     .onComplete(() => {
        //         textTweenGroup.remove(tween);
        //     })
        //     .start();

        // if (!isFilterApplied) {
        //     this.resetAllSymbols();
        // }

        // if (animationPromises.length > 0) {
        //     await Promise.all(animationPromises);
        // }
        // else {

        //     this.resetAllSymbols();
        //     Promise.resolve();
        // }
        // Promise.resolve();
    }

    protected resetAllSymbols() {
        this.allReelArray.forEach((reelObj) => {
            reelObj.symbols.forEach((symbol) => {
                // symbol.symbol.filters = [];
                symbol.view.tint = "0xffffff";
            })
        });
        DisplayComponent.get(ReelCellComponent).getInstance().makeUndark();
        DisplayComponent.get(WinMeterComponent).getInstance().makeUndark();
    }

    protected playWinLineAnimations(winlineNumbers: number[], timeScale: number): Promise<void> {
        return new Promise((resolve) => {
            // Clear any existing tracks
            this.winLinesSPine?.state.clearTracks();

            const animationPromises: Promise<void>[] = [];

            // Set paying line animations for each winning line
            for (let currentLineIndex = 0; currentLineIndex < winlineNumbers.length; currentLineIndex++) {
                const winLineId = winlineNumbers[currentLineIndex];
                const winAnimationName = `payline_${winLineId}`;

                const animationPromise = new Promise<void>((resolve2) => {
                    this.winLinesSPine!.state
                        .setAnimation(currentLineIndex, winAnimationName, false).listener = {
                        complete: () => {
                            resolve2();
                            this.winLinesSPine?.state.clearTracks();
                            this.winLinesSPine?.skeleton.setToSetupPose();
                            this.winLinesSPine!.state.clearListeners();
                        },
                    };

                    this.winLinesSPine!.state.timeScale = timeScale;
                });

                animationPromises.push(animationPromise);
            }

            // Resolve when all animations complete
            Promise.all(animationPromises).then(() => resolve());
        });
    }

    protected async blastAnimation(currentRespinIndex: number): Promise<void> {


        const animationPromises: Promise<void>[] = [];
        const timescale = isSuperQuickBtnOnGlobal ? 2 : 1;

        spinData.respins[currentRespinIndex].cascadePositions?.forEach((position) => {
            // reels.forEach((symbol, posNum) => {

            const reelNum = position[0];
            const posNum = position[1];

            let spineSymbol = this.allReelArray[reelNum].symbols[posNum].symbol;

            const animationPromise = new Promise<void>((resolve) => {
                spineSymbol.state.setAnimation(0, "blast", false).listener = {
                    // spineSymbol.state.setAnimation(0, "land", false).listener = {
                    complete: () => {
                        spineSymbol.state.clearListeners();
                        resolve();
                    },
                };

                spineSymbol.state.timeScale = timescale;

            });

            animationPromises.push(animationPromise);

        });






        try {
            if (animationPromises.length > 0) {

                sound.play('symbol_cascade', { volume: 0.3, speed: timescale });

                await Promise.all(animationPromises);
                // await new Promise(resolve => setTimeout(resolve, 100));

            }
        } catch (error) {
            console.error("Error during blastAnimation:", error);
            throw error;
        }
    }
}